import FocusAreas from "./FocusAreas";
import Clients from "./Clients";
import headerImage from "../../assets/images/DevopsHomePage.png";
import Mission from "./Mission";

const HomePage = () => (
  <div className="min-h-screen overflow-x-hidden">
    <div className="bg-[#F4F7FC] h-[420px]">
      <div className="flex justify-between items-center h-80 px-[80px]">
        <div className="w-3/4 h-full mt-[12rem]">
          <h1 className="text-5xl font-bold text-[#005BA1] mb-4">
            Welcome to DevXOps Competency
          </h1>
          <p className=" text-[#707070] mb-2 text-xl font-semibold">
            Empowering Teams, Optimizing Processes, Delivering Value Faster.
          </p>
          <p className="text-[#151515] text-xl mt-6 w-3/4 font-normal">
            At DevXOps by YASH, we integrate advanced technologies and DevOps
            practices to build intelligent, adaptive digital
            ecosystems—empowering businesses to innovate, scale, and grow beyond
            traditional limits.
          </p>
        </div>
        <div className="mt-[12rem]">
          <img
            src={headerImage}
            alt="DevXOps Illustration"
            className="h-[440px] w-auto"
          />
        </div>
      </div>
    </div>
    <div className="px-[80px]">
      <FocusAreas />
      <Clients />
      <Mission />
    </div>
  </div>
);

export default HomePage;
